<template src="./template.html"></template>
<script>
import { mapGetters } from 'vuex';
import { Tooltip } from '../../../directives/tooltip';

import Icon from 'vue-awesome/components/Icon'
import 'vue-awesome/icons/circle'
import 'vue-awesome/icons/info'
import 'vue-awesome/icons/gift'
import axios from 'axios';
import { PANEL_AVAILABLE } from '../../../store/types';

export default {
  props: ['removable'],
  components: { Icon },
  directives: { Tooltip },
  data(){
    return{
      toolText: 'Für jedes bestellte Solarstrom-Modul erhalten Sie 100 Franken aus dem Energiefonds der Stadt St.Gallen. Statt des ursprünglichen Preises von 499 Franken bezahlen Sie damit nur noch 399 Franken pro Solarstrom-Modul.'
    };
  },
  computed: {
    ...mapGetters(['get_wording', 'get_building_info', 'get_selected_panels', 'get_selected_building_slug', 'get_selection']),
    costSum(){
      let sum = this.get_selected_panels.reduce( (total, current) => total + parseFloat(current.panel_cost), 0);
      return sum.toFixed(2);
    },
  },
  methods: {
    removePanel(id) {
        const buildingId = this.get_selection.activeBuilding;
        const fieldId = this.get_selection.activeField;
        const panelApiRoute = `${this.$apiUrl}/building/${buildingId}/field/${fieldId}/panel/available`;
        axios.post(panelApiRoute, { panel_id: id });
        this.$store.dispatch('REMOVE_SELECTED_PANEL', id);
      if( this.get_selected_panels.length === 0){
        this.$router.push(`/${this.get_selected_building_slug}/step-2`);
      }
    },
  }
};

</script>



// WEBPACK FOOTER //
// src/components/modules/01_costtable/index.vue